import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Card, Modal, Spinner, InputGroup } from 'react-bootstrap';
import { useOutletContext, useParams, useNavigate, useLocation } from 'react-router-dom';
//import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import MatchPaginationComponent from '../components/pagination/MatchPaginationComponent.js'
import SpinnerComponent from '../components/progressbar/SpinnerComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover, stickyThStyle,
    filterActiveIndicator, backBtn
} from '../styles/goldTheme.js'

function SureModal(props) {
    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            animation={false}
            scrollable
        >
            <Modal.Header closeButton style={{ backgroundColor: 'lightgray' }} >
                <Modal.Title id="contained-modal-title-vcenter">
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center' }}>
                            <h4>Are you sure?</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ display: 'flex', justifyContent: 'center' }}>
                            <p style={{ marginTop: '0px', paddingTop: '0px' }} ><i><b>This option will mark all Imported Owners as Verified Receivers.</b></i></p>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px' }} >
                        <Col style={{ display: 'flex', justifyContent: 'center' }} >
                            <Button
                                onClick={props.onHide}
                                style={{ width: '100px', backgroundColor: 'red' }}
                            >
                                No
                            </Button>
                            <Button
                                type='button'
                                size='sm'
                                style={{ marginLeft: '20px', width: '100px', backgroundColor: 'green' }}
                                onClick={() => props.handleMapAllButton()}
                            >
                                Yes
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

const OwnerMappings = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();

    //stateful properties (hooks)
    const navigate = useNavigate();
    const params = useParams();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const [pageStatus, setPageStatus] = useState('loading');
    const [dataStatus, setDataStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [sureModalShow, setSureModalShow] = useState(false);
    const [owners, setOwners] = useState([]);
    const [dataCriteria, setDataCriteria] = useState({
        dataFileId: params.id,
        skipCount: 0,
        takeCount: 50,
        matchTakeCount: 2,
        ownerName: "",
        statementTypeId: null,
    });
    const [bootstrapped, setBootstrapped] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [matchCriteria, setMatchCriteria] = useState([{
        ownerId: 0,
        skipCount: 0,
        takeCount: 2,
        currentPage: 1,
        rowCount: 0,
        ownerName: "",
        address: "",
        city: "",
        state: "",
        zip: ""
    }]);

    const [screenHeight, setScreenHeight] = useState(100);

    const [sortByMatch, setSortByMatch] = useState(false);

    const [orderIds, setOrderIds] = useState([]);

    const ownersById = useMemo(
        () => new Map(owners.map(o => [o.receiverId, o])),
        [owners]
    );

    const location = useLocation();
    const [fileTypeId, setFileTypeId] = useState('1');
    const fileTypeIdString = fileTypeId;

    useEffect(() => {
        const ft = String(location.state?.fileTypeId ?? '1');

        setFileTypeId(ft);
        setDataCriteria(prev => ({
            ...prev,
            statementTypeId: Number(ft),
        }));

        if (setIsShowSidebarMd) setIsShowSidebarMd(true);
        setScreenHeight(window.innerHeight);
        setBootstrapped(true);
    }, [location.state?.fileTypeId]);


    useEffect(() => {
        if (!bootstrapped) return; //prevent early call
        if (dataCriteria.statementTypeId == null) return;

        (async () => {
            try {
                await populateOwners(1);
                setPageStatus('ready');
            } catch (ex) {
                setPageStatus('error'); setPageErrors(ex.message);
                setDataStatus('error'); setDataErrors(ex.message);
            }
        })();
    }, [bootstrapped, dataCriteria.statementTypeId]);

    useEffect(() => {
        if (!owners.length) {
            setOrderIds([]);  
            return;
        }
        setOrderIds(prev =>
            prev && prev.length
                ? reconcileOrder(prev, owners)
                : owners.map(o => o.receiverId)   
        );
    }, [owners]);


    //populate owners
    const populateOwners = async (currentPage, reset) => {
        //console.log('Current Page: ' + currentPage);
        var startMs = performance.now();
        //note: have to recalcaulate skipCount here since state updates aren't active until re-render
        let skipCount = (currentPage === 1 ? 0 : (currentPage - 1) * dataCriteria.takeCount);
        //console.log('Skip Count: ' + skipCount);

        //setDataStatus('loading');

        const currentCriteria = {
            dataFileId: dataCriteria.dataFileId,
            ownerName: (reset ? '' : dataCriteria.ownerName),
            skipCount: skipCount,
            takeCount: dataCriteria.takeCount,
            matchTakeCount: dataCriteria.matchTakeCount,
            statementTypeId: dataCriteria.statementTypeId
        }

        await getOwners(currentCriteria)
            .then(response => {
                if (!response.data.length) {
                    setDataStatus('nodata');
                    initializeMatchCriteria([]);
                    return;
                }

                setRowCount(response.data[0].rowCount);
                const normalizedOwners = response.data.map(o => ({
                    receiverMatches: o.receiverMatches || { rowCount: 0, data: [] },
                    ...o
                }));

                setOwners(normalizedOwners);
                initializeMatchCriteria(normalizedOwners);
                setDataStatus('ready');
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                var totalMs = Math.round(performance.now() - startMs);
                console.log(
                    "[populateOwners] totalMs=" + totalMs +
                    " page=" + String(currentPage) +
                    " skip=" + String(skipCount) +
                    " take=" + String(dataCriteria.takeCount) +
                    " ownerName=" + (reset ? "" : dataCriteria.ownerName)
                );
            })
    };

    //get owners
    const getOwners = async (criteria) => {
        //console.log('Getting Unmapped Owners...');

        const apiUrl = 'datafiles/'
            + criteria.dataFileId + '/unmappedreceivers?skipcount='
            + criteria.skipCount + '&takecount='
            + criteria.takeCount + '&matchtakecount='
            + criteria.matchTakeCount
            + (criteria.ownerName === "" ? '' : '&ownerName=' + criteria.ownerName)
            + '&statementTypeId=' + criteria.statementTypeId;

        //+ (criteria.ownerName === "" ? '' : '&ownerName=' + encodeURIComponent(criteria.ownerName));
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        //console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    //get owner matches
    const getOwnerMatches = async (criteria) => {
        console.log('Getting Owner Matches for OwnerId: ' + criteria.ownerId + ', OwnerName: ' + criteria.ownerName + ', Address: ' + criteria.address);

        ////note: using criteria param instead of matchCriteria from state so we can use current criteria
        //let apiUrl = baseUrl + 'companies/' + criteria.ownerId + '/receivermatches?skipcount=' + criteria.skipCount + '&takecount=' + criteria.takeCount
        //    + (criteria.ownerName === "" ? '' : '&receiverName=' + criteria.ownerName)
        //    + (criteria.address === "" ? '' : '&address=' + criteria.address)
        //    + (criteria.city === "" ? '' : '&city=' + criteria.city)
        //    + (criteria.state === "" ? '' : '&state=' + criteria.state)
        //    + (criteria.zip === "" ? '' : '&zip=' + criteria.zip);

        //console.log(apiUrl);
        //let json = await fetch(apiUrl)
        //    .then(response => response.json())
        //    .catch(ex => {
        //        throw ex;                                   //use this to throw the raw error object
        //        //throw new Error('Bad Url: ' + ex);        //use this to throw custom error message
        //    })

        //return { success: true, rowCount: json.rowCount, data: json.data };


        //note: using criteria param instead of matchCriteria from state so we can use current criteria
        const apiUrl = 'companies/' + criteria.ownerId + '/receivermatches?skipcount=' + criteria.skipCount + '&takecount=' + criteria.takeCount
            + (criteria.ownerName === "" ? '' : '&receiverName=' + criteria.ownerName)
            + (criteria.address === "" ? '' : '&address=' + criteria.address)
            + (criteria.city === "" ? '' : '&city=' + criteria.city)
            + (criteria.state === "" ? '' : '&state=' + criteria.state)
            + (criteria.zip === "" ? '' : '&zip=' + criteria.zip);
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, rowCount: json.rowCount, data: json.data };
    };

    //handle form control changes
    const handleChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        //console.log('Field: ' + fieldName + ', Value: ' + value);

        setDataCriteria({
            ...dataCriteria,
            [fieldName]: value
        });
    }

    //handle match criteria control changes
    const handleMatchCriteriaChange = (ownerId, event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        //console.log('ownerId: ' + ownerId, 'Field: ' + fieldName + ', Value: ' + value);

        const newMatchCriteria = [];
        matchCriteria.map(criteria => {
            if (criteria.ownerId === ownerId) {
                newMatchCriteria.push({
                    ...criteria,
                    [fieldName]: value
                });
            }
            else {
                newMatchCriteria.push(criteria);
            }
            //console.log('Updating match criteria for ownerId: ' + owner.receiverId + ', ' + owner.ownerName);
        });
        setMatchCriteria(newMatchCriteria);

        //newMatchCriteria.map(criteria => {
        //    console.log('New match criteria for ownerId: ' + criteria.ownerId + ', ' + criteria.skipCount + ', ' + criteria.takeCount + ', ' + criteria.ownerName + ', ' + criteria.address + ', ' + criteria.city + ', ' + criteria.state + ', ' + criteria.zip);
        //});
    }

    const initializeMatchCriteria = async (owners) => {
        const newMatchCriteria = [];
        owners.map(owner => {
            //console.log('Initializing match criteria for ownerId: ' + owner.receiverId + ', ' + owner.ownerName);

            newMatchCriteria.push({
                ownerId: owner.receiverId,
                skipCount: 0,
                takeCount: 2,
                currentPage: 1,
                ownerName: (owner.ownerName ?? '').substring(0, 12),
                address: '',
                city: '',
                state: '',
                zip: '',
                isChecked: false
            });
        });
        setMatchCriteria(newMatchCriteria);

        //newMatchCriteria.map(criteria => {
        //    console.log('New match criteria for ownerId: ' + criteria.ownerId + ', ' + criteria.skipCount + ', ' + criteria.takeCount + ', ' + criteria.ownerName + ', ' + criteria.address + ', ' + criteria.city + ', ' + criteria.state + ', ' + criteria.zip + ', ' + criteria.currentPage);
        //});
    }

    //suggested match testing
    function getStarRating(importedOwner, match) {

        const norm = s => (s || '').toLowerCase().trim();

        let fieldsMatched = 0;
        if (norm(importedOwner.ownerName) === norm(match.companyName)) fieldsMatched++;
        if (norm(importedOwner.address1) === norm(match.address1)) fieldsMatched++;
        if (norm(importedOwner.city) === norm(match.city)) fieldsMatched++;
        if (norm(importedOwner.state) === norm(match.state)) fieldsMatched++;
        const zipTrimmed = s => norm(s).substring(0, 5);
        if (zipTrimmed(importedOwner.zip) === zipTrimmed(match.zip)) fieldsMatched++;

        return fieldsMatched;
    }

    function getHighestStarForOwner(owner) {
        if (!owner.receiverMatches || !owner.receiverMatches.data || owner.receiverMatches.data.length === 0) {
            return 0; // No matches
        }
        return Math.max(...owner.receiverMatches.data.map(m => getStarRating(owner, m)));
    }


    //handle reset button
    const handleResetButton = async () => {

        setDataStatus('loading');

        setDataCriteria({
            ...dataCriteria,
            ownerName: '',
            skipCount: 0
        });

        setCurrentPage(1);

        await populateOwners(1, true);
    };

    //handle map selected button
    const handleMapSelectedButton = async () => {
        console.log('Mapping selected owners...');
        setDataStatus('loading');

        const selectedOwners = [];
        owners.map(owner => {
            if (!!owner.isChecked) {
                selectedOwners.push({
                    dataFileId: dataCriteria.dataFileId,
                    receiverId: owner.receiverId,
                    mapToReceiverId: owner.receiverId
                });
            } else {
                const receiverMatches = owner.receiverMatches.data;
                receiverMatches.map(match => {
                    if (!!match.isChecked) {
                        selectedOwners.push({
                            dataFileId: dataCriteria.dataFileId,
                            receiverId: owner.receiverId,
                            mapToReceiverId: match.id
                        });
                    }
                });
            }
        });

        console.log('Selected Owner Count: ' + selectedOwners.length);
        selectedOwners.map(selectedOwner => {
            console.log('Selected owner - OwnerId: ' + selectedOwner.receiverId + ', SelectedOwnerId: ' + selectedOwner.mapToReceiverId);
        });

        await mapSelectedOwners(selectedOwners, false)
            .then(response => {
                if (response.success) {
                    //TODO: repopulate owners
                    handleResetButton(1);
                    //note: data status is set to 'ready' in handleResetButton()
                    //setDataStatus('ready');
                }
                else {
                    //TODO: figure out what to do here
                    setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //handle map all button
    const handleMapAllButton = async () => {
        console.log('Mapping all owners...');
        setDataStatus('loading');
        setSureModalShow(false);

        const selectedOwners = [{
            dataFileId: dataCriteria.dataFileId,
            receiverId: 0,
            mapToReceiverId: 0
        }];

        console.log('Selected Owner Count: ' + selectedOwners.length);
        selectedOwners.map(selectedOwner => {
            console.log('Selected owner - OwnerId: ' + selectedOwner.receiverId + ', SelectedOwnerId: ' + selectedOwner.mapToReceiverId);
        });

        await mapSelectedOwners(selectedOwners, true)
            .then(response => {
                if (response.success) {
                    //TODO: repopulate owners
                    handleResetButton(1);
                    //note: data status is set to 'ready' in handleResetButton()
                    //setDataStatus('ready');
                }
                else {
                    //TODO: figure out what to do here
                    setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //populate owners
    const mapSelectedOwners = async (selectedOwners, mapAllUnverified) => {
        //console.log('Mapping Selected Owners...');

        //let apiUrl = baseUrl + 'accounts/' + currentAccount.id + '/mapReceivers/';
        //let body = JSON.stringify(selectedOwners);

        //console.log(apiUrl);
        //console.log(body);

        //let json = await fetch(apiUrl, {
        //    method: 'PUT',
        //    headers: { 'Content-Type': 'application/json' },
        //    body: JSON.stringify(selectedOwners)
        //    })
        //    .then(response => {
        //        if (response === true) {
        //            alert('true response');
        //        }
        //    })
        //    .catch(ex => {
        //        throw ex;                                   //use this to throw the raw error object
        //        //throw new Error('Bad Url: ' + ex);        //use this to throw custom error message
        //    })

        //return { success: true };



        const apiUrl = 'accounts/' + currentAccount.id + '/mapReceivers?mapAllUnverified=' + mapAllUnverified + '&statementTypeId=' + dataCriteria.statementTypeId;
        const jsonBody = JSON.stringify(selectedOwners);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);

        return { success: response.ok };
    };

    //submit form
    const submitForm = async (e) => {
        e.preventDefault();
        setDataStatus('loading');

        setDataCriteria(prev =>({
            ...prev,
            skipCount: 0
        }));

        setCurrentPage(1);

        await populateOwners(1);
    };

    //handle page click
    const handlePageClick = async (currentPage) => {
        //console.log('Current Page: ' + currentPage);

        setDataStatus('loading');

        setDataCriteria(prev => ({
            ...prev,
            skipCount: 0
        }));

        //don't need to do here, since pagination component sets before calling this method
        //setCurrentPage(1);

        await populateOwners(currentPage);
    };

    //handle owner checkbox click
    const handleOwnerCheckboxClick = async (ownerId) => {
        console.log('OwnerId: ' + ownerId);

        const newOwners = owners.map(owner => {
            if (owner.receiverId === ownerId) {
                const receiverMatches = owner.receiverMatches.data;
                const newMatches = receiverMatches.map(match => {
                    //set the match's checkbox to false (for every match)
                    return {
                        ...match,
                        isChecked: false
                    };
                });

                //flip the bit on the owner's checkbox
                const ownerChecked = !!owner.isChecked;
                return {
                    ...owner,
                    receiverMatches: { rowCount: owner.receiverMatches.rowCount, data: newMatches },
                    isChecked: !ownerChecked
                };
            }
            else {
                return owner;
            }
        });

        //newOwners.map(newOwner => {
        //    console.log('New owner - OwnerId: ' + newOwner.receiverId + ', OwnerName:' + newOwner.ownerName + ', IsChecked: ' + !!newOwner.isChecked);
        //    newOwner.receiverMatches.data.map(match => {
        //        console.log('MatchId: ' + match.id + ', MatchName:' + match.companyName + ', IsChecked: ' + !!match.isChecked);
        //    });
        //});

        setOwners(newOwners);
    };

    //handle match reset button click
    const handleMatchResetClick = async (owner, _unusedIndex, currentPage) => {
        const take = (getCriteriaByOwnerId(owner.receiverId)?.takeCount) || 10;
        const skipCount = currentPage === 1 ? 0 : (currentPage - 1) * take;

        setCriteriaForOwner(owner.receiverId, {
            ownerName: owner.ownerName,
            address: "",
            city: "",
            state: "",
            zip: "",
            currentPage,
            skipCount
        });

        await populateOwnerMatches(owner, currentPage, true);
    };



    //handle match search button click
    const handleMatchSearchClick = async (owner, _unusedIndex, currentPage) => {
        const take = (getCriteriaByOwnerId(owner.receiverId)?.takeCount) || 10;
        const skipCount = currentPage === 1 ? 0 : (currentPage - 1) * take;

        setCriteriaForOwner(owner.receiverId, { currentPage, skipCount });
        await populateOwnerMatches(owner, currentPage);
    };



    //handle match page click
    const handleMatchPageClick = async (owner, currentPage, takeCount) => {
        const skipCount = currentPage === 1 ? 0 : (currentPage - 1) * (takeCount || 10);
        setCriteriaForOwner(owner.receiverId, { currentPage, skipCount });
        await populateOwnerMatches(owner, currentPage);
    };


    //populate owner matches
    const populateOwnerMatches = async (owner, currentPage = 1, reset = false) => {
        const mc = getCriteriaByOwnerId(owner.receiverId) || {};
        const take = mc.takeCount || 10;
        const skipCount = currentPage === 1 ? 0 : (currentPage - 1) * take;

        const criteria = {
            ownerId: owner.receiverId,
            ownerName: reset ? owner.ownerName : (mc.ownerName || ""),
            address: reset ? "" : (mc.address || ""),
            city: reset ? "" : (mc.city || ""),
            state: reset ? "" : (mc.state || ""),
            zip: reset ? "" : (mc.zip || ""),
            skipCount,
            takeCount: take
        };

        const response = await getOwnerMatches(criteria);
        setOwners(prev =>
            prev.map(o =>
                o.receiverId === owner.receiverId
                    ? { ...o, receiverMatches: response }
                    : o
            )
        );
    };


    //handle match checkbox click
    const handleMatchCheckboxClick = async (ownerId, matchId) => {
        console.log('OwnerId: ' + ownerId, ', MatchId: ' + matchId);

        const newOwners = owners.map(owner => {
            if (owner.receiverId === ownerId) {
                const receiverMatches = owner.receiverMatches.data;
                const newMatches = receiverMatches.map(match => {
                    if (match.id === matchId) {
                        //flip the bit on the match's checkbox
                        const matchChecked = !!match.isChecked;
                        return {
                            ...match,
                            isChecked: !matchChecked
                        };
                    }
                    else {
                        //set the match's checkbox to unchecked
                        return {
                            ...match,
                            isChecked: false
                        };
                    }
                });

                //set the owner's checkbox to unchecked
                return {
                    ...owner,
                    receiverMatches: { rowCount: owner.receiverMatches.rowCount, data: newMatches },
                    isChecked: false
                };
            }
            else {
                return owner;
            }
        });

        //newOwners.map(newOwner => {
        //    console.log('New owner - OwnerId: ' + newOwner.receiverId + ', OwnerName:' + newOwner.ownerName + ', IsChecked: ' + !!newOwner.isChecked);
        //    newOwner.receiverMatches.data.map(match => {
        //        console.log('MatchId: ' + match.id + ', MatchName:' + match.companyName + ', IsChecked: ' + !!match.isChecked);
        //    });
        //});

        setOwners(newOwners);
    };

    const handleKeypress = async (e, owner, currentPage) => {
        if (e.key !== 'Enter') return;
        const take = (getCriteriaByOwnerId(owner.receiverId)?.takeCount) || 10;
        const skipCount = currentPage === 1 ? 0 : (currentPage - 1) * take;

        setCriteriaForOwner(owner.receiverId, { currentPage, skipCount });
        await populateOwnerMatches(owner, currentPage);
    };

    const handleToggleSort = () => {
        setSortByMatch(prev => {
            const next = !prev;
            const cmp = next ? bestCompare : alphaCompare;
            const sorted = [...owners].sort(cmp);
            setOrderIds(sorted.map(o => o.receiverId));
            return next;
        });
    };

    const setMatchCurrentPage = (owner, pageNumber) => {
        //console.log('OwnerId: ' + owner.receiverId + ', PageNumber: ' + pageNumber);

        //matchCriteria.map(criteria => {
        //    if (criteria.ownerId === owner.receiverId) {
        //        console.log('Pre match state criteria - OwnerId: ' + criteria.ownerId + ', PageNumber: ' + criteria.currentPage);
        //    }
        //});

        const newMatchCriteria = [];
        matchCriteria.map(criteria => {
            if (criteria.ownerId === owner.receiverId) {
                newMatchCriteria.push({
                    ...criteria,
                    currentPage: pageNumber
                });
            }
            else {
                newMatchCriteria.push(criteria);
            }
        });

        //newMatchCriteria.map(criteria => {
        //    if (criteria.ownerId === owner.receiverId) {
        //        console.log('New match criteria - OwnerId: ' + criteria.ownerId + ', PageNumber: ' + criteria.currentPage);
        //    }
        //});

        setMatchCriteria(newMatchCriteria);

        //matchCriteria.map(criteria => {
        //    if (criteria.ownerId === owner.receiverId) {
        //        console.log('Post match state criteria - OwnerId: ' + criteria.ownerId + ', PageNumber: ' + criteria.currentPage);
        //    }
        //});
    };

    const getMatchCurrentPage = (owner, msg) => {
        //console.log('Getting CurrentPage for OwnerId: ' + owner.receiverId);

        //console.log('Match Criteria Count: ' + matchCriteria.length);
        let currPage = 0;
        matchCriteria.map(criteria => {
            if (criteria.ownerId === owner.receiverId) {
                //if (criteria.ownerId == 2) {
                //    console.log('Match criteria - OwnerId: ' + criteria.ownerId + ', PageNumber: ' + criteria.currentPage + ', Msg: ' + (msg ?? ''));
                //}
                currPage = criteria.currentPage;

            }
        });

        return currPage;
    };

    const getCriteriaByOwnerId = (ownerId) => matchCriteria.find(c => c.ownerId === ownerId);

    const setCriteriaForOwner = (ownerId, patch) => {
        setMatchCriteria(prev => {
            const exists = prev.some(c => c.ownerId === ownerId);
            return exists
                ? prev.map(c => c.ownerId === ownerId ? { ...c, ...patch } : c)
                : [
                    ...prev,
                    {
                        ownerId,
                        ownerName: "",
                        address: "",
                        city: "",
                        state: "",
                        zip: "",
                        takeCount: 10,
                        currentPage: 1,
                        skipCount: 0,
                        ...patch
                    }];
        });
    };

    const alphaCompare = (a, b) => (a.ownerName || '').localeCompare(b.ownerName || '');

    const bestCompare = (a, b) => {
        const as = getHighestStarForOwner(a);
        const bs = getHighestStarForOwner(b);
        if (bs !== as) return bs - as;
        return alphaCompare(a, b);
    };

    const reconcileOrder = (prevIds, ownersList) => {
        const currentIds = ownersList.map(o => o.receiverId);
        const keep = prevIds.filter(id => currentIds.includes(id));
        const add = currentIds.filter(id => !prevIds.includes(id));
        return [...keep, ...add];
    };

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const LoadingSpinner = ({ text = "Loading..." }) => (
        <div
            style={{
                minHeight: '200px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Spinner
                animation="border"
                variant="primary"
                style={{ width: '3rem', height: '3rem', marginBottom: '1rem' }}
            />
            <span style={{ color: '#555', fontSize: '1.1rem' }}>{text}</span>
        </div>
    );

    const showPageLoading = () =>
        <LoadingSpinner
            text="Loading page..."
            style={{
                color: COLORS.gold
            }}
        />;

    //render page loading
    const showDataLoading = () => <LoadingSpinner text="Loading data..." />;

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    //render table container
    const showTableContainer = () => {
        return (
            <Card className="mb-4" style={{ background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 14px rgba(0,0,0,.10)' }}>
                <Card.Header style={{ background: '#333333', color: '#f1f1f1', borderBottom: 'none', padding: '12px 16px' }}>
                    <Row className="align-items-center">
                        <Col>{showInputCriteria()}</Col>
                        <Col xs="auto">
                            <small style={{ color: '#6b7280' }}>
                                {fileTypeIdString === '2' ? 'JIB mapping' : fileTypeIdString === '4' ? '1099 Mapping' : 'Revenue mapping'}
                            </small>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    {(() => {
                        switch (dataStatus) {
                            case 'nodata':
                                return <p>No Data Loaded.</p>
                            case 'loading':
                                return showDataLoading()
                            case 'ready':
                                return showData()
                            case 'error':
                                return showDataError()
                            default:
                                return <Row>No Data Loaded.</Row>
                        }
                    })()}
                </Card.Body>
                <Card.Footer style={{ background: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
                    <Container>
                        <Row>
                            <Col className="d-flex justify-content-end">
                                <PaginationComponent
                                    itemsCount={rowCount}
                                    itemsPerPage={dataCriteria.takeCount}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    pageClickHandler={handlePageClick}
                                    alwaysShown={false}
                                    itemStyle={{ ...paginationStyle }}
                                    activeItemStyle={{ ...activePaginationStyle }}
                                />
                            </Col>
                        </Row>
                    </Container>
                </Card.Footer>
            </Card>
        );
    }

    const isFieldMatch = (a, b) => (a || '').toLowerCase().trim() === (b || '').toLowerCase().trim();
    const isZipMatch = (a, b) => (a || '').toLowerCase().trim().substring(0, 5) === (b || '').toLowerCase().trim().substring(0, 5);
    const ids = orderIds.length ? orderIds : owners.map(o => o.receiverId);

    //render owners
    const showData = () => {
        return (
            <Container>
                <Row>
                    <ul style={{ listStyleType: "none", maxHeight: "60vh", overflowY: 'auto' }}>
                        {ids.map((id) => {
                            const owner = ownersById.get(id);
                            if (!owner) {
                                return null;
                            }
                            const mc = getCriteriaByOwnerId(owner.receiverId) || {};
                            return (
                                <li key={owner.receiverId} style={{ marginBottom: "0px" }} >
                                    <Card style={{ background: 'transparent', border: 'none', borderBottom: '1px solid #f3f4f6' }}>
                                        {/*<Card.Header>{owner.ownerName}</Card.Header>*/}
                                        <Card.Body style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                            <Container>
                                                <Row>
                                                    <Col xs="3">
                                                        <Container>
                                                            <Row>
                                                                <Col>
                                                                    <div style={{ fontWeight: "bold", fontSize: '12px', color: '#6e5f20' }}>Imported Owner Info:</div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <label
                                                                    htmlFor={`chkSelect-${owner.receiverId}`}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        cursor: 'pointer',
                                                                        padding: '6px',
                                                                        userSelect: 'none',
                                                                    }}
                                                                >
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`chkSelect-${owner.receiverId}`}
                                                                        label=""
                                                                        checked={!!owner.isChecked}
                                                                        onChange={() => handleOwnerCheckboxClick(owner.receiverId)}
                                                                        style={{ marginTop: '4px', marginRight: '8px', cursor: 'pointer' }}
                                                                    />
                                                                    <div style={{ fontSize: '11px', color: '#374151' }} >
                                                                        <div>{owner.ownerName}</div>
                                                                        <div>{(owner.additionalNameInfo != null && owner.additionalNameInfo !== '') ? "(" + owner.additionalNameInfo + ")" : ""}</div>
                                                                        <div>{owner.address1}</div>
                                                                        <div>{owner.address2}</div>
                                                                        <div>{owner.address3}</div>
                                                                        <div>{owner.city}, {owner.state} {owner.zip}</div>

                                                                    </div>
                                                                </label>
                                                                <div style={{ marginBottom: '4px' }} >
                                                                    <Button id={"s" + owner.receiverId} variant="primary" size="sm" style={{ width: "80px", marginTop: "5px", fontSize: '11px' }} value={owner.receiverId}
                                                                        onClick={(e) => handleMatchResetClick(owner, 1)}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button id={"s" + owner.receiverId} variant="primary" size="sm" style={{ width: "80px", marginTop: "5px", marginLeft: "10px", fontSize: '11px' }} value={owner.receiverId}
                                                                        onClick={() => handleMatchSearchClick(owner, 1)}>
                                                                        Search
                                                                    </Button>
                                                                </div>
                                                            </Row>
                                                        </Container>
                                                    </Col>


                                                    <Col xs="9" style={{ borderLeft: "1px solid #e5e7eb" }}>
                                                        <Container>
                                                            <Row>
                                                                <Col>
                                                                    <div style={{ fontWeight: "bold", fontSize: '12px', color: '#6e5f20' }}>Owner Search:</div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <table className="table table-striped" aria-labelledby="tabelLabel" style={{ '--bs-table-bg': 'transparent', '--bs-table-striped-bg': 'rgba(0,0,0,.03)', '--bs-table-border-color': '#e5e7eb', color: '#1f2937' }}>
                                                                    <thead>
                                                                        <tr style={{ fontSize: '11px', color: '#6e5f20' }}>
                                                                            <th>&nbsp;</th>
                                                                            <th
                                                                                style={{ width: '150px' }}
                                                                            ><div>Name</div>
                                                                                <div>
                                                                                    <Form.Control
                                                                                        name="ownerName"
                                                                                        size="sm"
                                                                                        style={{ fontSize: '11px', width: '150px' }}
                                                                                        aria-label="Owner Name"
                                                                                        value={mc.ownerName ?? ""}
                                                                                        onChange={(e) => handleMatchCriteriaChange(owner.receiverId, e)}
                                                                                        onKeyPress={(e) => handleKeypress(e, owner, 1)}
                                                                                    />
                                                                                </div>
                                                                            </th>
                                                                            <th
                                                                                style={{ width: '200px' }}
                                                                            ><div>Address</div>
                                                                                {/*<div>*/}
                                                                                {/*    <Form.Control name="address" size="sm" style={{ fontSize: '11px' }} aria-label="Owner Address" value={matchCriteria[index].address} onChange={(e) => handleMatchCriteriaChange(owner.receiverId, e)} onKeyPress={(e) => handleKeypress(e, owner, index, 1)} />*/}
                                                                                {/*</div>*/}
                                                                            </th>
                                                                            <th
                                                                                style={{ width: '150px' }}
                                                                            ><div>City</div>
                                                                                {/*<div>*/}
                                                                                {/*    <Form.Control name="city" size="sm" style={{ fontSize: '11px' }} aria-label="Owner City" value={matchCriteria[index].city} onChange={(e) => handleMatchCriteriaChange(owner.receiverId, e)} onKeyPress={(e) => handleKeypress(e, owner, index, 1)} />*/}
                                                                                {/*</div>*/}
                                                                            </th>
                                                                            <th
                                                                                style={{ width: '150px' }}
                                                                            ><div>State</div>
                                                                                {/*<div>*/}
                                                                                {/*    <Form.Control name="state" size="sm" style={{ fontSize: '11px' }} aria-label="Owner State" value={matchCriteria[index].state} onChange={(e) => handleMatchCriteriaChange(owner.receiverId, e)} onKeyPress={(e) => handleKeypress(e, owner, index, 1)} />*/}
                                                                                {/*</div>*/}
                                                                            </th>
                                                                            <th
                                                                                style={{ width: '150px' }}
                                                                            ><div>Zip</div>
                                                                                {/*<div>*/}
                                                                                {/*    <Form.Control name="zip" size="sm" style={{ fontSize: '11px' }} aria-label="Owner Zip" value={matchCriteria[index].zip} onChange={(e) => handleMatchCriteriaChange(owner.receiverId, e)} onKeyPress={(e) => handleKeypress(e, owner, index, 1)} />*/}
                                                                                {/*</div>*/}
                                                                            </th>
                                                                            <th
                                                                                style={{ width: '150px' }}
                                                                            >
                                                                                Match
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {owner.receiverMatches.data
                                                                            .slice()
                                                                            .sort((a, b) =>
                                                                                getStarRating(owner, b) - getStarRating(owner, a)
                                                                            )
                                                                            .map((ownerMatch) => (
                                                                                <tr
                                                                                    key={ownerMatch.id}
                                                                                    style={{ cursor: 'pointer', fontSize: '11px' }}
                                                                                    onClick={() => handleMatchCheckboxClick(owner.receiverId, ownerMatch.id)}
                                                                                >
                                                                                    <td>
                                                                                        <Form.Check
                                                                                            type="checkbox"
                                                                                            id="chkSelect"
                                                                                            label=""
                                                                                            style={{ cursor: 'pointer' }}
                                                                                            checked={!!ownerMatch.isChecked}
                                                                                            onChange={() => handleMatchCheckboxClick(owner.receiverId, ownerMatch.id)}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            style={{
                                                                                                borderBottom: isFieldMatch(owner.ownerName, ownerMatch.companyName) ? '3px solid #16C60C' : '3px solid #E81123'
                                                                                            }}
                                                                                        >
                                                                                            {ownerMatch.companyName}
                                                                                        </span>
                                                                                        <br />
                                                                                        {(ownerMatch.additionalNameInfo != null
                                                                                            && ownerMatch.additionalNameInfo !== '') ? "(" + ownerMatch.additionalNameInfo + ")" : ""}
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            style={{
                                                                                                borderBottom: isFieldMatch(owner.address1, ownerMatch.address1) ? '3px solid #16C60C' : '3px solid #E81123'
                                                                                            }}
                                                                                        >
                                                                                            {ownerMatch.address1}
                                                                                        </span>
                                                                                        <br />{ownerMatch.address2}<br />{ownerMatch.address3}</td>
                                                                                    <td>
                                                                                        <span
                                                                                            style={{
                                                                                                borderBottom: isFieldMatch(owner.city, ownerMatch.city) ? '3px solid #16C60C' : '3px solid #E81123'
                                                                                            }}
                                                                                        >
                                                                                            {ownerMatch.city}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            style={{
                                                                                                borderBottom: isFieldMatch(owner.state, ownerMatch.state) ? '3px solid #16C60C' : '3px solid #E81123'
                                                                                            }}
                                                                                        >
                                                                                            {ownerMatch.state}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            style={{
                                                                                                borderBottom: isZipMatch(owner.zip, ownerMatch.zip) ? '3px solid #16C60C' : '3px solid #E81123'
                                                                                            }}
                                                                                        >
                                                                                            {ownerMatch.zip}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        {[...Array(5)].map((_, i) =>
                                                                                            <FontAwesomeIcon
                                                                                                key={i}
                                                                                                icon={i < getStarRating(owner, ownerMatch) ? faStarSolid : faStarRegular}
                                                                                                style={{ color: i < getStarRating(owner, ownerMatch) ? "#FFD700" : "#ccc", marginRight: "2px" }}
                                                                                            />
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                    </tbody>
                                                                </table>
                                                                {/*{(() => {*/}
                                                                {/*    if (owner.receiverMatches.rowCount === 0) {*/}
                                                                {/*        return <Row><p style={{ marginLeft: "20px", fontSize: '14px' }}>No matches returned for the specified criteria.</p></Row>*/}
                                                                {/*    }*/}
                                                                {/*})()}*/}
                                                            </Row>
                                                            <Row>
                                                                <Col className="d-flex justify-content-end">
                                                                    <MatchPaginationComponent
                                                                        criteriaIndex={owner.receiverId}
                                                                        owner={owner}
                                                                        itemsCount={owner.receiverMatches.rowCount}
                                                                        itemsPerPage={mc.takeCount || 10}
                                                                        currentPage={mc.currentPage || 1}
                                                                        setCurrentPage={setMatchCurrentPage}
                                                                        pageClickHandler={handleMatchPageClick}
                                                                        alwaysShown={false}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Card.Body>
                                    </Card>
                                </li>
                            )
                        }
                        )}
                    </ul>
                </Row>
            </Container>
        );
    }

    //pagination example
    //https://github.com/lukaaspl/ellipsis-pagination/blob/master/src/components/Pagination.js

    //render input criteria
    const showInputCriteria = () => {
        return (
            <Container>
                <Form>
                    <Row style={{ height: '30px' }}>
                        <Col xs="auto" style={{ paddingLeft: '20px' }} >
                            <Form.Group className="mb-3" controlId="ownerName">
                                <Form.Label style={{ ...formLabel, fontSize: '14px', fontWeight: '600' }}>Owner Name</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="ownerName">
                                {/*<Form.Label style={{ fontSize: '14px' }}>Owner Name</Form.Label>*/}
                                <Form.Control
                                    name="ownerName"
                                    size="sm"
                                    style={{ fontSize: '12px' }}
                                    aria-label="Owner Name"
                                    value={dataCriteria.ownerName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-3" controlId="buttonReset">
                                {/*<Form.Label as={Row}><br /></Form.Label>*/}
                                <Button
                                    type='button'
                                    size='sm'
                                    disabled={pageStatus !== 'ready'}
                                    style={{ ...btnGold, width: "80px", fontSize: '12px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    onClick={pageStatus === 'ready' ? handleResetButton : null}
                                >
                                    Reset
                                </Button>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-3" controlId="buttonSubmit">
                                {/*<Form.Label as={Row}><br /></Form.Label>*/}
                                <Button
                                    type='submit'
                                    size='sm'
                                    disabled={pageStatus !== 'ready'}
                                    style={{ ...btnGold, width: "80px", fontSize: '12px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    onClick={pageStatus === 'ready' ? submitForm : null}
                                >
                                    Search
                                </Button>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group as={Col} className="mb-3" controlId="buttonMap">
                                {/*<Form.Label as={Row}><br /></Form.Label>*/}
                                <Button
                                    type='button'
                                    size='sm'
                                    disabled={dataStatus !== 'ready'}
                                    style={{ ...btnGold, width: "120px", fontSize: '12px' }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    onClick={dataStatus === 'ready' ? handleMapSelectedButton : null}
                                >
                                    Map Selected
                                </Button>
                            </Form.Group>
                        </Col>
                        {(() => {
                            if (!baseUrl.startsWith("https://totdata-api.")) {
                                return <Col xs="auto">
                                    <Form.Group as={Col} className="mb-3" controlId="buttonMap">
                                        {/*<Form.Label as={Row}><br /></Form.Label>*/}
                                        <Button
                                            type='button'
                                            variant='warning'
                                            size='sm'
                                            disabled={dataStatus !== 'ready'}
                                            style={{ width: "120px", fontSize: '12px' }}
                                            onClick={dataStatus === 'ready' ? () => setSureModalShow(true) : null}
                                        >
                                            Map All
                                        </Button>
                                    </Form.Group>
                                </Col>
                            }
                        })()}
                        <Col xs="auto" className="ms-auto">
                            <Form.Group className="mb-3" controlId="sortByMatches">
                                <Button
                                    size="sm"
                                    variant={sortByMatch ? "secondary" : "primary"}
                                    style={{ marginBottom: '10px', fontSize: '12px' }}
                                    onClick={handleToggleSort}
                                >
                                    {sortByMatch ? "Sort Alphabetically" : "Sort by Best Match"}
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }

    return (
        <div>
            <Container fluid>
                <Row style={{ marginBottom: '10px' }}>
                    <Col
                        xs={1}
                        style={{ marginLeft: '-13px' }}
                    >
                        <span
                            style={{ ...backBtn }}
                            onClick={() => navigate('/datafiles')}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </span>
                    </Col>
                </Row>
                {(() => {
                    switch (pageStatus) {
                        case 'loading':
                            return showPageLoading()
                        case 'ready':
                            return showTableContainer()
                        case 'error':
                            return showPageError()
                        default:
                            return <p>No Page Loaded.</p>
                    }
                })()}
            </Container>

            <SureModal
                show={sureModalShow}
                onHide={() => setSureModalShow(false)}
                handleMapAllButton={handleMapAllButton}
            />
        </div>
    );
}

export default OwnerMappings;
